import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/educationSafety/img/1.avif';
import image2 from '@src/assets/images/solution/educationSafety/img/2.avif';
import image3 from '@src/assets/images/solution/educationSafety/img/3.avif';
import image4 from '@src/assets/images/solution/educationSafety/img/4.avif';

import customer1 from '@src/assets/images/solution/publicFire/img/customer1.avif';
import function1 from '@src/assets/images/solution/educationSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/educationSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/educationSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/educationSafety/img/function4.avif';
import { educationSafety1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: 'Giải pháp trường học',

  banner: {
    title: 'Bảo vệ an toàn trường học thông minh với AI phân tích hình ảnh',
    desc: 'AI sử dụng hình ảnh từ hệ thống CCTV hiện có để phát hiện hành vi bất thường và tình huống nguy hiểm trong trường, đồng thời đảm bảo bảo vệ thông tin cá nhân.',
  },

  recommend: {
    title: '',
    desc: 'ORBRO OS là nền tảng mạnh mẽ để theo dõi vị trí thời gian thực và giám sát thông minh.<br/>Tích hợp hoàn hảo công nghệ BLE, UWB và AI phân tích hình ảnh, giúp nâng cao độ an toàn, hiệu suất và khả năng mở rộng của hệ thống.',
    labels: {
      desktop: [
        { img: educationSafety1, data: recommendation.ipCamera },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.ipCamera }, { data: recommendation.edgeAi }, { data: recommendation.switch }],
    },
  },

  summary: {
    title: 'Phát hiện nguy hiểm theo thời gian thực và phản hồi ngay lập tức',
    desc: 'AI sử dụng công nghệ nhận dạng tư thế để phát hiện ngay hành vi bạo lực, ngã, mất ý thức hoặc hành động bất thường của học sinh ở hành lang, cầu thang, lớp học và phòng thí nghiệm—giúp ngăn ngừa sự cố sớm và phản ứng nhanh.',
    function: {
      card: [
        {
          image: function1,
          title: 'Tự động phát hiện hành vi bạo lực (đánh nhau)',
          desc: 'Phân tích tư thế cho thấy xung đột như đấm, đẩy và cảnh báo quản lý ngay lập tức để ngăn xung đột kịp thời.',
        },
        {
          image: function2,
          title: 'Phát hiện ngã trên hành lang hoặc cầu thang và cảnh báo',
          desc: 'Nhận diện hành vi ngã dựa trên tư thế và gửi cảnh báo tức thì giúp phản ứng khẩn cấp nhanh chóng.',
        },
        {
          image: function3,
          title: 'Phát hiện trạng thái nằm lâu trên sàn hoặc mất ý thức',
          desc: 'Phát hiện trạng thái bất thường khi học sinh nằm im lâu sau khi ngã và gửi cảnh báo ngay lập tức.',
        },
        {
          image: function4,
          title: 'Tự động phát hiện hành vi bất thường (chạy, hành động đột ngột)',
          desc: 'Phát hiện hành vi chạy nhanh hoặc đột ngột trong hành lang/cầu thang, giúp phòng ngừa va đập và tai nạn.',
        },
      ],
    },
  },

  numOfCard: {
    title: 'Tối ưu hóa vận hành an toàn trường học với công nghệ AI',
    desc: 'Phát hiện thời gian thực hành vi bất thường và tình huống nguy hiểm trong trường, giúp ứng phó nhanh và hiệu quả.',
    card: [
      {
        tag: '98%',
        title: 'Độ chính xác phát hiện hành vi bất thường',
        desc: 'Phân tích AI chính xác giúp xác định và phản hồi kịp thời mọi tình huống bất thường.',
      },
      {
        tag: '95%',
        title: 'Giảm nhân sự vận hành',
        desc: 'Hệ thống tự động hóa giảm đáng kể nhu cầu nhân sự và tăng hiệu quả quản lý.',
      },
      {
        tag: '100%',
        title: 'Tuân thủ bảo mật thông tin cá nhân',
        desc: 'Không quay video liên tục – chỉ ghi ngắn khi sự kiện xảy ra để đảm bảo quyền riêng tư.',
      },
    ],
  },

  func: [
    {
      theme: 'Các tính năng AI tiên tiến giúp phát hiện và ứng phó chính xác với nguy cơ trong trường',
      title: 'Ghi tự động phản hồi theo tình huống',
      desc: 'AI ước lượng tư thế phân tích chuyển động mạnh, hành vi bất thường hay hung hãn để phát hiện nguy cơ tự động và hỗ trợ phản hồi chính xác kịp thời.',
      sub1: 'Phân tích độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Cập nhật trạng thái tức thì',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: 'Cảnh báo ngay lập tức theo 5 mức độ rủi ro',
      desc: 'AI phân loại rủi ro thành 5 cấp độ và gửi cảnh báo tức thì đến người phụ trách, cho phép ứng phó phù hợp tùy mức độ.',
      sub2: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: 'Vận hành độc lập trên nền tảng on-premise',
      desc: 'Triển khai trên máy chủ của trường để giảm sự phụ thuộc bên ngoài, đảm bảo kiểm soát dữ liệu và cải tiến hệ thống nhanh chóng.',
      sub1: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Phân tích độ chính xác cao',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: 'Ghi video sự kiện bảo mật thông tin cá nhân',
      desc: 'Chỉ ghi clip ngắn khi phát hiện sự kiện rủi ro, đảm bảo bảo mật thông tin và hạn chế lưu trữ không cần thiết.',
      sub1: 'Thiết lập vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ nhiều vùng',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: 'Tóm tắt tính năng',
    desc: 'Đảm bảo an toàn giúp nâng cao hiệu quả và giảm thiểu tổn thất. ORBRO cung cấp chức năng toàn diện để xử lý nguy cơ trong môi trường trường học, bao gồm vùng nguy hiểm, sự cố đột xuất và các rủi ro do thiết bị.',
    data: [
      {
        icon: IconAnalytics,
        title: 'AI tự động phát hiện hành vi nguy hiểm',
        desc: 'Tự động phân tích hành vi mạnh, bất thường hay hung hãn để nhận diện rủi ro theo thời gian thực.',
      },
      {
        icon: IconChartBar,
        title: 'Cảnh báo rủi ro 5 cấp độ',
        desc: 'Phân loại rủi ro thành 5 cấp độ và gửi cảnh báo rõ ràng, nhanh chóng.',
      },
      {
        icon: IconSearch,
        title: 'Lưu video dựa trên sự kiện',
        desc: 'Chỉ lưu clip khi phát hiện bất thường, tăng cường bảo mật cá nhân.',
      },
      {
        icon: IconLayers,
        title: 'Tận dụng hệ thống CCTV hiện có',
        desc: 'Kết nối AI với camera hiện tại mà không cần đầu tư thêm thiết bị.',
      },
      {
        icon: IconRoute,
        title: 'Triển khai tại vùng cụ thể',
        desc: 'Áp dụng phân tích video AI tại các khu vực ưu tiên như phòng chăm sóc học sinh.',
      },
      {
        icon: IconLayers,
        title: 'Vận hành độc lập tại chỗ',
        desc: 'Máy chủ nội bộ giúp vận hành nhanh và tự chủ.',
      },
      {
        icon: IconChartBar,
        title: 'Tối thiểu hóa nhân sự vận hành',
        desc: 'Quản lý tự động và giảm chi phí nhân sự.',
      },
      {
        icon: IconSearch,
        title: 'Bảo mật thông tin cá nhân nâng cao',
        desc: 'Không quay liên tục, chỉ lưu khi cần thiết để bảo vệ quyền riêng tư.',
      },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Danh mục sản phẩm',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
